import * as squint_core from 'squint-cljs/core.js';
import * as dom from './cljdoc.client.dom.jsx';
import * as cljdoc_DOT_client_DOT_dom from './cljdoc.client.dom.jsx';
import * as lib from './cljdoc.client.library.jsx';
import * as cljdoc_DOT_client_DOT_library from './cljdoc.client.library.jsx';
import * as page from './cljdoc.client.page.jsx';
import * as cljdoc_DOT_client_DOT_page from './cljdoc.client.page.jsx';
var init_scroll_indicator = function () {
const def_detail_scroll_view_1 = dom.query(".js--main-scroll-view");
const def_nav_scroll_view_2 = dom.query(".js--namespace-contents-scroll-view");
const def_detail_blocks_3 = dom.query_all(".def-block", def_detail_scroll_view_1);
const def_nav_items_4 = dom.query_all(".def-item", def_nav_scroll_view_2);
const is_elem_visible_QMARK__5 = (function (container, el) {
const map___6_8 = el.getBoundingClientRect();
const map___6_9 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___6_8))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___6_8))) ? (map___6_8) : (squint_core.seq_to_map_for_destructuring(map___6_8)))) : (map___6_8));
const y_10 = squint_core.get(map___6_9, "y");
const height_11 = squint_core.get(map___6_9, "height");
const etop_12 = y_10;
const ebottom_13 = (etop_12 + height_11);
const cbottom_14 = window.innerHeight;
const ctop_15 = (cbottom_14 - container.clientHeight);
if ((etop_12 <= cbottom_14)) {
return (ebottom_13 >= ctop_15)} else {
return false};

});
const draw_scroll_indicator_16 = (function () {
let ndx_17 = squint_core.count(def_detail_blocks_3);
let in_indicator_block_18 = false;
let indicator_block_found_19 = false;
while(true){
const ndx_20 = (ndx_17 - 1);
if ((ndx_20 >= 0)) {
const detail_el_21 = squint_core.get(def_detail_blocks_3, ndx_20);
const show_indicator_QMARK__22 = ((squint_core.truth_(def_detail_scroll_view_1)) ? (((squint_core.truth_(def_nav_scroll_view_2)) ? (((!indicator_block_found_19) && (is_elem_visible_QMARK__5(def_detail_scroll_view_1, detail_el_21)))) : (def_nav_scroll_view_2))) : (def_detail_scroll_view_1));
const nav_item_el_23 = squint_core.get(def_nav_items_4, ndx_20);
if (squint_core.not(show_indicator_QMARK__22)) {
dom.remove_class(nav_item_el_23, "scroll-indicator")} else {
dom.add_class(nav_item_el_23, "scroll-indicator");
if ((ndx_20 === 0)) {
def_nav_scroll_view_2.scrollTop = 1} else {
if (squint_core.not(is_elem_visible_QMARK__5(def_nav_scroll_view_2, nav_item_el_23))) {
nav_item_el_23.scrollIntoView()} else {
}}};
let G__24 = ndx_20;
let G__25 = show_indicator_QMARK__22;
let G__26 = ((indicator_block_found_19) ? (indicator_block_found_19) : (((squint_core.not(show_indicator_QMARK__22)) && (in_indicator_block_18))));
ndx_17 = G__24;
in_indicator_block_18 = G__25;
indicator_block_found_19 = G__26;
continue;
};
;break;
}
;

});
if (squint_core.truth_(def_detail_scroll_view_1)) {
def_detail_scroll_view_1.addEventListener("scroll", draw_scroll_indicator_16)};
return draw_scroll_indicator_16();

};
var is_element_out_of_view = function (elem) {
const rect_1 = elem.getBoundingClientRect();
if ((rect_1.top > window.innerHeight)) {
return true} else {
return (rect_1.bottom < 0)};

};
var restore_sidebar_scroll_pos = function () {
const temp__6897__auto___1 = dom.query(".js--main-sidebar");
if (squint_core.truth_(temp__6897__auto___1)) {
const main_side_bar_2 = temp__6897__auto___1;
const sidebar_scroll_state_3 = JSON.parse((() => {
const or_4_5 = sessionStorage.getItem("sidebarScroll");
if (squint_core.truth_(or_4_5)) {
return or_4_5} else {
return "null"};

})());
sessionStorage.removeItem("sidebarScroll");
if (squint_core.truth_(window.location.search)) {
return null} else {
if (squint_core.truth_(((squint_core.truth_(sidebar_scroll_state_3)) ? (squint_core._EQ_(lib.coords_path_from_current_loc(), sidebar_scroll_state_3.libVersionPath)) : (sidebar_scroll_state_3)))) {
return main_side_bar_2.scrollTop = sidebar_scroll_state_3.scrollTop} else {
const temp__6897__auto___6 = dom.query("a.b", main_side_bar_2);
if (squint_core.truth_(temp__6897__auto___6)) {
const selected_elem_7 = temp__6897__auto___6;
if (squint_core.truth_(is_element_out_of_view(selected_elem_7))) {
return selected_elem_7.scrollIntoView(({"behavior": "instant", "block": "start"}));
};
};
};
};
};

};
var save_sidebar_scroll_pos = function () {
const temp__6897__auto___1 = dom.query(".js--main-sidebar");
if (squint_core.truth_(temp__6897__auto___1)) {
const main_side_bar_2 = temp__6897__auto___1;
const anchor_elems_3 = dom.query_all("a", main_side_bar_2);
for (let G__4 of squint_core.iterable(anchor_elems_3)) {
const anchor_5 = G__4;
anchor_5.addEventListener("click", (function () {
const scroll_top_6 = main_side_bar_2.scrollTop;
const data_7 = ({"libVersionPath": lib.coords_path_from_current_loc(), "scrollTop": scroll_top_6});
return sessionStorage.setItem("sidebarScroll", JSON.stringify(data_7));

}))
}
return null;
};

};
var init = function () {
if (squint_core.truth_(page.is_namespace())) {
init_scroll_indicator();
return document.addEventListener("DOMContentLoaded", (function () {
save_sidebar_scroll_pos();
return restore_sidebar_scroll_pos();

}));
};

};

export { init }
